// extracted by mini-css-extract-plugin
export default {"container":"Home_container__AHomM","wrapper":"Home_wrapper__IA6WD","title":"Home_title__qAdt+","grid":"Home_grid__iVcPY"};